module.exports = __webpack_public_path__ + "img/appBarMovile.b1df29b6.png";